import cc from 'classcat';
import { observer } from 'mobx-react';
import * as React from 'react';
import { withRouter } from 'react-router';
import { SpeechData } from '../stores';
import { AsyncImg } from './AsyncImg';
import { Media } from './Media';
import { OptionalLink } from './OptionalLink';
import { Speakers } from './Speakers';
import styles from './Speech.styl';

export interface SpeechProps {
    data: SpeechData;
    path?: string;
}

@(withRouter as ClassDecorator)
@observer
export class Speech extends React.Component<SpeechProps> {
    render() {
        const { data, path } = this.props;
        const { Title, Location, Conference, Date, Country, Text, flag, conferenceLink } = data;
        return (
            <div className={cc([styles.container])}>
                <div className={cc([styles.speech])}>
                    <div className={styles.side}>
                        <Speakers data={data} />
                        <div className={styles.wherewhen}>
                            <p className={styles.confname}>
                                <OptionalLink href={conferenceLink}>{Conference}</OptionalLink>
                            </p>
                            <p className={styles.location}>{Location}, <AsyncImg srcPromise={flag} /> {Country}</p>
                            <p className={styles.date}>{Date}</p>
                        </div>
                    </div>
                    <div className={styles.description}>
                        <OptionalLink to={path} className={styles.link}>
                            <h2 className={styles.title}>{Title}</h2>
                        </OptionalLink>
                        <p className={styles.text}>{Text}</p>
                        <Media data={data} path={path} />
                    </div>
                </div>
            </div>
        );
    }
}

